import { GuestModel, UserAuthModel, useCities, useDialog } from '@/logic/state';

import getConfig from 'next/config';
import isEmpty from 'lodash/isEmpty';
import shallow from 'zustand/shallow';
import { storage } from '../libs';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { UserModel } from '@/features/login-and-signup/types/user-model';
import { PATHS } from '@/constants/routes';

// this hook is used to display 'select city form' when enter the website for the first time

export const useSelectInitialCity = () => {
  const setDialog = useDialog(s => s.setDialog, shallow);
  const router = useRouter();
  const cities = useCities(s => s.cities, shallow);

  const { citiesList } = cities;
  const isCitiesListEmpty = isEmpty(citiesList);
  const citiesListDepsString = JSON.stringify(citiesList);

  const user: UserAuthModel | UserModel = storage?.user?.get();
  const guest: GuestModel = storage?.guest?.get();

  const userPreferredCityId = user?.preferredCityId;
  const guestPreferredCityId = guest?.preferredCityId;

  const { publicRuntimeConfig } = getConfig();

  useEffect(() => {
    if (
      publicRuntimeConfig.maintenance === 'false' &&
      router.pathname !== PATHS.UNDER_MAINTENANCE &&
      !router.query.cityId
    ) {
      if (user && !userPreferredCityId) {
        setDialog({
          wrapper: true,
          isCitiesForm: true,
          citiesFormPayload: {
            isUser: true,
          },
        });
      } else if (!guestPreferredCityId && !userPreferredCityId) {
        setDialog({
          wrapper: true,
          isCitiesForm: true,
          citiesFormPayload: {
            isUser: false,
          },
        });
      } else if (
        userPreferredCityId &&
        !isCitiesListEmpty &&
        !citiesList.find(city => city.id === userPreferredCityId)
      ) {
        setDialog({
          wrapper: true,
          isCitiesForm: true,
          citiesFormPayload: {
            isUser: true,
          },
        });
      } else if (
        guestPreferredCityId &&
        !userPreferredCityId &&
        !isCitiesListEmpty &&
        !citiesList.find(city => city.id === guestPreferredCityId)
      ) {
        setDialog({
          wrapper: true,
          isCitiesForm: true,
          citiesFormPayload: {
            isUser: false,
          },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    citiesListDepsString,
    publicRuntimeConfig.maintenance,
    router.pathname,
    router.query.cityId,
  ]);
};
